<div class="p-6">
  <div class="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
    <h3 class="font-bold">{{ '::Sommeliers' | abpLocalization }}</h3>
    <div class="flex flex-col md:flex-row gap-2 md:ml-auto">
      <app-metro-button
        variant="secondary"
        text=""
        [icon]="excelIcon"
        [iconSize]="'18'"
        [iconColor]="'#1C2D36'"
        [loading]="isExporting"
        (clicked)="generateExcel()">
      </app-metro-button>

      <app-metro-button
        variant="secondary"
        text="{{ '::AddSommelier' | abpLocalization }}"
        (clicked)="openCreateModal()">
      </app-metro-button>
    </div>
  </div>

  <div class="flex flex-col md:flex-row mt-3 gap-4 items-end">
    <div class="flex-1 w-full">
      <app-metro-search-input (search)="onSearch($event)"
            (cleared)="onClearSearch()"></app-metro-search-input>
    </div>
    <div class="w-full md:w-64">
      <app-metro-form-select
        placeholder="{{ '::Status' | abpLocalization }}"
        [options]="statusOptions"
        [(ngModel)]="searchSommelier.status"
        (selectionChange)="onStatusChange($event)"
        [allowSearch]="false"
      ></app-metro-form-select>
    </div>
  </div>

  <div class="flex items-center justify-between mt-4 mb-2">
    <span class="text-sm text-gray-500">
      {{ data.totalCount }} {{ '::SommeliersFound' | abpLocalization }}
    </span>
  </div>

  <div class="flex flex-col overflow-x-auto rounded-lg border-1 border-gray-700">
    @if (isLoading) {
      <app-metro-table-skeleton [columns]="columns"></app-metro-table-skeleton>
    } @else {
      <app-metro-table [columns]="columns" [data]="data.items" [actions]="actions" [actionsMenu]="true" [pageSize]="10"
        [currentPage]="list.page + 1" (pageChange)="onPageChange($event)" [isServerPaginated]="true" [totalItems]="data.totalCount">
      </app-metro-table>
    }
  </div>

  <!-- #339 / CU-44 — baja de sommelier con reasignación de clientes -->
  <app-metro-modal
    [isOpen]="showReassignModal"
    [title]="'::ReassignClientsTitle' | abpLocalization"
    [confirmText]="'::DeactivateAndReassign' | abpLocalization"
    [closeOnConfirm]="false"
    (close)="closeReassignModal()"
    (cancelAction)="closeReassignModal()"
    (confirm)="confirmReassign()">
    <div class="font-sans space-y-4">
      <p class="text-gray-700">
        {{ '::SommelierHasClients' | abpLocalization: reassignClientCount }}
      </p>

      <label class="flex items-center gap-2 text-sm text-gray-700">
        <input type="checkbox" [(ngModel)]="reassignUseInstitutional" />
        {{ '::UseInstitutionalAccount' | abpLocalization }}
      </label>

      @if (!reassignUseInstitutional) {
        <app-metro-form-select
          [placeholder]="'::SelectDestinationSommelier' | abpLocalization"
          [options]="activeSommelierOptions"
          [(ngModel)]="reassignTargetId"
          [allowSearch]="true">
        </app-metro-form-select>
      }
    </div>
  </app-metro-modal>
</div>
